import { HazmatControllerUs } from "@routemax/hazmat";
import hazmatInfo from "./jsonFiles/hazmatInfo.json";
import placardInfo from "./jsonFiles/placardInfo.json";
import segregationRules from "./jsonFiles/segregationRules.json";
import segregationRuleWeights from "./jsonFiles/segregationRuleWeights.json";

const hazmatController = new HazmatControllerUs({
  hazmatInfo,
  placardInfo,
  segregationRules,
  segregationRuleWeights,
});

export default hazmatController;
